import { Injectable, Injector } from '@angular/core';
import { DialogRef } from '../../../dialog/dialog-ref';
import { DialogService } from '../../../dialog/dialog.service';
import { DialogShowMode } from '../../../dialog/enums/dialog-show-mode.enum';
import { TasksDialogPayload } from './tasks-dialog-payload.interface';
import { TasksDialogComponent } from './tasks-dialog.component';

@Injectable()
export class TasksDialogService {
  constructor(
    private readonly injector: Injector,
    private readonly dialogService: DialogService
  ) {}

  public open(payload: TasksDialogPayload): DialogRef<any[]> {
    return this.dialogService.open<TasksDialogPayload, any[]>(TasksDialogComponent, payload, {
      showMode: DialogShowMode.Side,
      closeButton: false,
      closeOnNavigation: true,
      width: '800px',
      injector: this.injector,
    });
  }
}
